import React, {Component} from 'react';

import AppLayout from '../lib/AppLayout';
import apiService from '../lib/apiService';
import RiderLogo from '../lib/RiderLogo';
import Loading from '../lib/Loading';
import Success from '../lib/Success';
import Failed from '../lib/Failed';
import validateLength from '../lib/validateLength';

const validateEighth = validateLength(8);

export default class Reset extends Component {
  constructor(props, context) {
    super(props, context);
    const {query, params} = props;
    ['onSubmit', 'onChange'].forEach(fn => this[fn] = this[fn].bind(this));
    this.state = {
      pass1valid: true,
      pass2valid: true,
      errorList: [],
      success: false,
      submitted: false,
      pass1: '',
      pass2: '',
      ...query,
      ...params
    };
  }

  validateLocally() {
    const {pass1, pass2} = this.state;
    var {pass1valid, pass2valid, errorList} = this.state;

    errorList = [];
    pass1valid = true;
    pass2valid = true;
    if (!validateEighth(pass1)) {
      errorList.push('At least 8 characters');
      pass1valid = false;
    } else if (pass1 !== pass2) {
      errorList.push('Passwords do not match');
      pass2valid = false;
    }

    this.setState({
      errorList,
      pass1valid,
      pass2valid,
    });
  }

  onChange({target}) {
    this.setState({
      [target.id]: target.value,
      submitted: false,
    }, function() {
      this.validateLocally();
    });
  }

  onSubmit(e) {
    e.preventDefault();

    const {pass1, token, uuid, errorList} = this.state;

    if (errorList.length) return;

    this.setState({
      isLoading: true,
      submitted: true
    })

    apiService('/password/reset/', 'POST', {
      'new_password': pass1,
      token,
      uuid
    })
    .then(response =>
      response.text().then(text => ({
        response: response,
        text
      })
    ))
    .then(
      ({response, text}) => {
        var json;
        try {
          json = JSON.parse(text);
        } catch(e) {
          // console.log(`JSON parse error: ${e}`)
        }
        this.setState({
          success: response.ok,
          responseStatus: response.status,
          isLoading: false,
          responseJSON: json,
          responseText: text,
        });
      })
  }

  render() {
    const {
      pass2valid,
      errorList,
      pass1,
      pass2,
      isLoading,
      success,
      submitted,
      responseJSON,
      responseText,
      responseStatus,
    } = this.state;

    var pass1valid = this.state.pass1valid;

    if (isLoading) {
      return <Loading />
    }

    if (submitted && success) {
      return <AppLayout>
        <Success
          title='Success!'
          message='You can now login to the app using your new password.'
        />
      </AppLayout>
    }

    if (submitted && !success) {
      var unexpected_error;
      try {
        if (responseJSON) {
          if (responseJSON.detail.token) {
            // fall through to detailed failure with invalid tokens.
            if (responseJSON.detail.token[0].code !== 'invalid') {
              errorList.push(responseJSON.detail.token[0].message);
            }
          } else {
            if (responseJSON.detail.uuid) {
              errorList.push(responseJSON.detail.uuid[0].message);
            }
            if (responseJSON.detail.new_password) {
              pass1valid = false;
              errorList.push(responseJSON.detail.new_password[0].message);
            }
          }
        }
      } catch(e) {
        unexpected_error = <p>
            <strong>Unexpected error when handling response:</strong>
            <br />
            {e.toString()}
            <br /><br />
          </p>
      }

      // Unexpected error, display server response.
      if (!errorList.length || unexpected_error) {
        const response = responseJSON
            ? JSON.stringify(responseJSON, null, 2)
            : responseText;
        return <AppLayout>
          <Failed
            title={
               <span>Password Reset Failed (status {responseStatus}).</span>
            }
            message={
              <div>
              {unexpected_error}
              <p>You can try requesting a new link from within the app, or
                contact support if the problem persists.</p>
              <div className="App-Card-details">
              <h5><strong>Technical details (server response):</strong></h5>
              <pre>
                {response}
              </pre>
              </div>
              </div>
            }
          />
        </AppLayout>
      }
    }

    const hasErrors = errorList.length;
    var errorMessage = '';
    if (errorList.length) {
      if (errorList.length > 1) {
        errorMessage = <ul>
          {errorList.map((error, index) => <li key={index}>{error}</li>)}
        </ul>
      } else {
        errorMessage = errorList[0];
      }
    }
    return <AppLayout>
      <div className="App-Card">
        <RiderLogo />
        <h1 className='App-Card-title'>Reset Your Password</h1>
        <p className='App-Card-message'></p>{/*here for the spacing*/}
        <form onSubmit={this.onSubmit}>
          <input
            id='pass1'
            className={
              `App-input ${pass1valid ? '' : 'App-input-error'}`
            }
            value={pass1}
            type='password'
            onChange={this.onChange}
            placeholder='New Password'
          />

          <input
            id='pass2'
            className={
              `App-input ${pass2valid ? '' : 'App-input-error'}`
            }
            value={pass2}
            type='password'
            onChange={this.onChange}
            placeholder='Confirm New Password'
          />
          <div className={
            `App-input-comment ${hasErrors ? 'App-input-error' : ''}`
          }>
            {errorMessage}
          </div>
          <button
            className='App-Card-button'
            type="submit"
          >
            {'Reset password'}
          </button>
        </form>
      </div>
    </AppLayout>
  }
}



// WEBPACK FOOTER //
// ./src/views/Reset.js